import classNames from 'classnames';
import React from 'react';
import { getNid, prefix, WebUI } from "../../wui-core/src/index";
import { AnyObject, ModalBodyProps } from './iModal';

const defaultProps: Partial<ModalBodyProps> = {
    componentClass: 'div' as keyof JSX.IntrinsicElements,
    clsPrefix: `${prefix}-modal-body`
};

const ModalBody: React.FC<ModalBodyProps> = (props) => {
    const {
        componentClass: Component = defaultProps.componentClass as keyof JSX.IntrinsicElements,
        clsPrefix = defaultProps.clsPrefix as string,
        className,
        ...restProps
    } = props;

    const classes: AnyObject = {};
    classes[`${clsPrefix}`] = true;
    const adapterNid = getNid(props);

    return <Component
        onCancel={(event) => {
            event.stopPropagation()
        }}
        {...restProps}
        className={classNames(className, classes)}
        {...adapterNid}
    />
};

export default WebUI({name: "modal-body", defaultProps})(ModalBody) as React.FC<Partial<ModalBodyProps>>;